import { MessageService } from '@philips-internal/oswald-ui-core/lib/services';
let painScaleValue;
addEventListener('setVitalSignPainScaleValue', (e) => {
    const ce = e;
    painScaleValue = ce.detail.painScaleValue;
});
export const VITAL_SIGN_PAIN_SCALE_TYPE_VALIDATOR = 'vital-sign-pain-scale-type-validator';
async function vitalSignPainScaleTypeValidator(value) {
    let valid = false;
    let message = '';
    if (painScaleValue && painScaleValue > 0) {
        valid = (value && value.cd) ? true : false;
    }
    else {
        valid = true;
    }
    if (!valid) {
        message = MessageService.translate('message.type-scale-pain');
    }
    painScaleValue = undefined;
    return [{
            message: message,
            name: VITAL_SIGN_PAIN_SCALE_TYPE_VALIDATOR,
            valid: valid
        }];
}
export default vitalSignPainScaleTypeValidator;
//# sourceMappingURL=vital-sign-pain-scale-type-validator.js.map